/**
 * Created by Vasilenko on 12-Nov-16.
 */
export var Position = (function () {
    function Position(x, y) {
        var _this = this;
        this.x = x;
        this.y = y;
        this.clone = function () { return new Position(_this.x, _this.y); };
    }
    return Position;
}());
//# sourceMappingURL=position.model.js.map